import { PageLayout, StatusPageHeader } from '@/components';
import styles from './MaintenancePage.module.css';

export function MaintenancePage() {
  return (
    <PageLayout centerText>
      <StatusPageHeader />

      <p className={`text-muted ${styles.tagline}`}>Down for maintenance&hellip;</p>
    </PageLayout>
  );
}
